import { Fragment, useEffect, useRef } from "react";
import { QuotePlaceholderBlurImg } from "src/pages/OfferPage/pinouts/Pinout/QuotePlaceholderBlurImg";
import { ts } from "src/utils/translate"
import { PinoutData } from "src/pages/OfferPage/pinouts/PinoutConverter";
import { NHCPinoutDevices } from "src/model/api/nhc-pinout-devices";
import { QuoteCableList, QuotePinout } from "src/pages/OfferPage/pinouts/Pinout/pinout";
import $ from "jquery";
import {CableListDevice} from "src/model/api/cable-list-device.model";
import { getFrontendURL } from "src/utils/url";

export const Pinout = (props: {
  projectId: string | undefined,
  pinoutData: undefined | boolean | PinoutData,
  nhcPinoutData: NHCPinoutDevices
  cablelist: CableListDevice[]
}) => {
  const { pinoutData, cablelist, nhcPinoutData } = props;

  const pinoutRef = useRef<HTMLDivElement>(null);
  const cablelistRef = useRef<HTMLDivElement>(null);

  const nhcDataLength =
      nhcPinoutData !== null &&
      nhcPinoutData !== undefined &&
      Array.isArray(nhcPinoutData.pinoutElements)
          ? nhcPinoutData.pinoutElements.length
          : 0;

  useEffect(() => {
    if (
        !!pinoutData &&
        cablelist !== null &&
        cablelist !== undefined
    ) {
      if (pinoutRef.current != null) {
        let newPinout = new QuotePinout($(pinoutRef.current), pinoutData);
        newPinout.resultToContainer();

        if (cablelistRef.current != null) {
          let newCableList = new QuoteCableList(
              $(cablelistRef.current),
              cablelist as any,
              newPinout.getPageNum()
          );
          newCableList.resultToContainer();
        }
      }
    }
  }, [pinoutData, cablelist]);

  return pinoutData ? (
      <Fragment>
        {!nhcDataLength ? (
            <h3 className="remove-on-export pinout-header" style={{margin: "45px 15px 25px", fontWeight: 300}}>{ts("q_pinout", "Pinout")}</h3>
        ) : null}
        <div ref={pinoutRef}></div>
        {cablelist ? (
            <div ref={cablelistRef}></div>
        ) : null}
      </Fragment>
  ) : pinoutData === null ? (
      <Fragment>
        {!nhcDataLength ? (
            <h2 className="remove-on-export" style={{margin: "45px 15px 25px"}}>{ts("q_pinout", "Pinout")}</h2>
        ) : null}
        <QuotePlaceholderBlurImg
            cls="pinout lightshadow"
            num={1}
            opacity={0.3}
            img={`${getFrontendURL()}/images/placeholders/wiring_placeholder.png`}
        />
        <QuotePlaceholderBlurImg
            cls="pinout lightshadow"
            num={1}
            opacity={0.3}
            img={`${getFrontendURL()}/images/placeholders/cabling_placeholder.png`}
        />
      </Fragment>
  ) : null;
};
